import React from 'react';
import { Layout, Card, Space, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, HeartFilled } from '@ant-design/icons';
import AppHeaderHomePageTemplate from '../Organism/AppHeaderHomePageTemplate';
import Footer from '../Atoms/Footer';

const { Content } = Layout;

const WomensMessageWall: React.FC = () => {
  const navigate = useNavigate();

  // Sample messages - Replace with actual data from API
  const messages = [
    { id: 1, message: "Happy Women's Day to all the amazing women out there!", emoji: '🌸', author: 'Anonymous', date: '2026-03-08' },
    { id: 2, message: "Celebrating strength, courage, and resilience today!", emoji: '💪', author: 'Anonymous', date: '2026-03-08' },
    { id: 3, message: "Here's to strong women: may we know them, may we be them, may we raise them.", emoji: '👑', author: 'Anonymous', date: '2026-03-08' },
  ];

  return (
    <Layout className="min-h-screen flex flex-col">
      <AppHeaderHomePageTemplate />
      
      <Content className="flex-grow" style={{ background: 'linear-gradient(135deg, #FFF5F7 0%, #FFE4E9 100%)' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
          {/* Header */}
          <div style={{ marginBottom: '30px' }}>
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/')}
              style={{
                marginBottom: '20px',
                borderColor: '#FF69B4',
                color: '#FF1493',
              }}
            >
              Back to Home
            </Button>
            <h1 style={{
              color: '#FF1493',
              fontSize: '36px',
              fontWeight: 'bold',
              margin: 0,
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
            }}>
              💐 Women's Day Message Wall
            </h1>
            <p style={{ color: '#8629A4', fontSize: '16px', marginTop: '10px' }}>
              Celebrating the amazing women in our lives
            </p>
          </div>

          {/* Messages Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
            gap: '20px',
          }}>
            {messages.map((msg) => (
              <Card
                key={msg.id}
                style={{
                  background: '#FFFFFF',
                  borderRadius: '16px',
                  border: '2px solid #FFB6C1',
                  boxShadow: '0 4px 12px rgba(255, 20, 147, 0.1)',
                }}
                hoverable
              >
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                  <div style={{
                    fontSize: '48px',
                    textAlign: 'center',
                  }}>
                    {msg.emoji}
                  </div>
                  <p style={{
                    fontSize: '16px',
                    color: '#333',
                    textAlign: 'center',
                    minHeight: '60px',
                  }}>
                    {msg.message}
                  </p>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderTop: '1px solid #FFE4E9',
                    paddingTop: '12px',
                  }}>
                    <span style={{ color: '#8629A4', fontSize: '14px' }}>{msg.author}</span>
                    <Button
                      type="text"
                      icon={<HeartFilled style={{ color: '#FF1493' }} />}
                      style={{ color: '#FF1493' }}
                    />
                  </div>
                </Space>
              </Card>
            ))}
          </div>
        </div>
      </Content>

      <Footer />
    </Layout>
  );
};

export default WomensMessageWall;
